"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Production = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _decimal = require("./decimal.js");

var _decimal2 = _interopRequireDefault(_decimal);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _polynomial = require("./polynomial");

var _polynomial2 = _interopRequireDefault(_polynomial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProdUnit = function () {
  // TODO
  function ProdUnit(name, count, children) {
    var _this = this;

    _classCallCheck(this, ProdUnit);

    this.name = name;
    this.count = new _decimal2.default(count);
    // children: other units produced by this one
    this.children = {};

    var _loop = function _loop(_name) {
      var p = _this.children[_name] = {
        each: children[_name],
        total: function total() {
          return _this.count.times(p.each);
        }
      };
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(children || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _name = _step.value;

        _loop(_name);
      }
      // these are populated by Production
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.parents = {};
    this.polynomial = [this.count];
  } // TODO


  _createClass(ProdUnit, [{
    key: "degreeAt",
    value: function degreeAt(degree0, sec) {
      return (0, _polynomial2.default)(this.polynomial.slice(degree0), sec);
    }
  }, {
    key: "countAt",
    value: function countAt(sec) {
      return this.degreeAt(0, sec);
    }
  }, {
    key: "velocityAt",
    value: function velocityAt(sec) {
      return this.degreeAt(1, sec);
    }
  }, {
    key: "accelerationAt",
    value: function accelerationAt(sec) {
      return this.degreeAt(2, sec);
    }
  }]);

  return ProdUnit;
}();

var PolyPath = function () {
  // TODO

  function PolyPath(path) {
    _classCallCheck(this, PolyPath);

    this.path = path;
  }

  _createClass(PolyPath, [{
    key: "head",
    value: function head() {
      return this.path[0];
    }
  }, {
    key: "tail",
    value: function tail() {
      return this.path[this.path.length - 1];
    }
  }, {
    key: "parent",
    value: function parent() {
      return this.tail().parent;
    }
  }, {
    key: "child",
    value: function child() {
      return this.head().child;
    }
  }, {
    key: "degree",
    value: function degree() {
      return this.path.length;
    }
  }, {
    key: "coefficient",
    value: function coefficient() {
      var coeff = this.parent().count;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.path[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var path = _step2.value;

          coeff = coeff.times(path.each);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return coeff;
    }

    // create PolyPaths for producer's producers

  }, {
    key: "nextDegree",
    value: function nextDegree() {
      var _this2 = this;

      return Object.keys(this.parent().parents).map(function (name) {
        var path = _this2.parent().parents[name];
        return new PolyPath(_this2.path.concat([path]));
      });
    }
  }]);

  return PolyPath;
}();

var Production = exports.Production = function () {
  function Production(types, counts) {
    _classCallCheck(this, Production);

    this.units = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = Object.keys(types)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var name = _step3.value;

        this.units[name] = new ProdUnit(name, counts[name] || 0, types[name]);
      }
      // we know what each unit produces, reverse it to produced-by.
      // Start building the polynomial graph while we're at it.
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var polypath = [];
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = Object.keys(this.units)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var parentName = _step4.value;

        var parent = this.units[parentName];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = Object.keys(parent.children)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var childName = _step5.value;

            var child = this.units[childName];
            var path = child.parents[parentName] = parent.children[childName];
            path.parent = parent;
            path.child = child;
            polypath.push(new PolyPath([path]));
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
      // build the production polynomial, starting from first degree (drone->meat) and moving upward.
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    while (polypath.length > 0) {
      var poly = polypath.pop();
      poly.child().polynomial[poly.degree()] = (poly.child().polynomial[poly.degree()] || new _decimal2.default(0)).plus(poly.coefficient());
      Array.prototype.push.apply(polypath, poly.nextDegree());
    }
  }

  _createClass(Production, [{
    key: "countAt",
    value: function countAt(sec) {
      return this.degreeAt(0, sec);
    }
  }, {
    key: "velocityAt",
    value: function velocityAt(sec) {
      return this.degreeAt(1, sec);
    }
  }, {
    key: "accelerationAt",
    value: function accelerationAt(sec) {
      return this.degreeAt(2, sec);
    }
  }, {
    key: "degreeAt",
    value: function degreeAt(degree, sec) {
      return _lodash2.default.mapValues(this.units, function (unit) {
        return unit.degreeAt(degree, sec);
      });
    }
  }]);

  return Production;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../growth/lib/growth.js
// module id = 794
// module chunks = 0